import { useMemo } from 'react'
import { Column } from 'src/shared/components/Semantic/all'
import { Image } from 'src/shared/components/ui'
import { Category } from '../types'
import { getCategoryImageUrl } from '../categoryImages'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const CategoryCard = ({
  category,
  onClick,
}: {
  category: Category
  onClick: () => void
}) => {
  const { t } = useLocalization()
  const imageUrl = useMemo(
    () => getCategoryImageUrl(category.label),
    [category.label]
  )

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      }}
      className="catalog-category-card cursor-pointer p-3"
    >
      <Column className="gap-2.5">
        <div className="catalog-category-image">
          <Image
            src={imageUrl}
            alt=""
            className="size-full object-contain"
            loading="lazy"
          />
        </div>
        <h3 className="text-center text-sm leading-snug px-0.5 break-words">
          {t(category.label)}
        </h3>
      </Column>
    </div>
  )
}
